import React, { useState, useEffect } from 'react';
import {
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import useAdminRequest from '../../../requests/AdminRequest';
import Loader from '../../common/Loader';

function MessageDetails({ item, errorHandler }) {
  const [showMessage, setShowMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const { getTraceEvents } = useAdminRequest();

  useEffect(() => {
    console.log(item);
    refresh();
  }, [item]);

  const refresh = async () => {
    setLoading(true);
    const data = await getTraceEvents(item.sms_id, item.email_id, errorHandler);
    setEvents(data);
    setLoading(false);
  };

  const eventClass = (event) => {
    if (event.error) return 'error.main';
    if (event.log_message.toLowerCase().includes('failed')) return 'error.main';
    if (event.log_message.toLowerCase().includes('success'))
      return 'success.light';
    if (event.log_message.toLowerCase().includes('error')) return 'error.main';
    return '';
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          <Typography>
            <strong>Sent By:</strong> {item.customer_user_name} of{' '}
            {item.customer_name}
            {item.ip_address && (
              <>
                <br />
                <strong>From:</strong> {item.ip_address}
              </>
            )}
          </Typography>
          <Typography>
            <strong>Last Updated:</strong>{' '}
            {new Intl.DateTimeFormat('en-us', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
            }).format(new Date(item.last_updated))}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ marginY: 2 }} />

      <Typography gutterBottom>
        <span
          onClick={() => setShowMessage(!showMessage)}
          className="clickable"
        >
          <strong>To:</strong> {item.destination}
        </span>
        {showMessage && (
          <>
            <br />
            <strong>Message:</strong> {item.message}
          </>
        )}
      </Typography>

      <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Tag</TableCell>
              <TableCell>Log Message</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={3}>
                  <Loader />
                </TableCell>
              </TableRow>
            )}
            {events &&
              events.map((event, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ color: eventClass(event) }}>
                    {new Intl.DateTimeFormat('en-us', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric',
                    }).format(new Date(event.created_at))}
                  </TableCell>
                  <TableCell sx={{ color: eventClass(event) }}>
                    {event.tag}
                  </TableCell>
                  <TableCell sx={{ color: eventClass(event) }}>
                    {event.log_message}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default MessageDetails;
